import type {PublishedProductCatalogSnapshot} from '../../../packages/catalog/product-catalog.ts';
import type {createBusinessRuntime} from '../../../packages/runtime/business-runtime.ts';
import type {CustomerPaymentProofUploadPort} from './customer-payment-proof-upload.ts';

type BusinessRuntime = ReturnType<typeof createBusinessRuntime>;

export interface CustomerRuntimeHost {
  readonly runtime: BusinessRuntime;
  readonly catalog: PublishedProductCatalogSnapshot;
  readonly businessDate: () => string;
  /** Optional until deployment provides a durable cross-device upload service. */
  readonly paymentProofUpload?: CustomerPaymentProofUploadPort;
}

type CustomerGlobal = typeof globalThis & {
  __MOREFUNOS_CUSTOMER_RUNTIME__?: CustomerRuntimeHost;
};

export function resolveCustomerRuntimeHost(): CustomerRuntimeHost | null {
  const candidate = (globalThis as CustomerGlobal).__MOREFUNOS_CUSTOMER_RUNTIME__;
  if (!candidate?.runtime || !candidate.catalog || typeof candidate.businessDate !== 'function') return null;
  return candidate;
}
